import { Button, Carousel, Col, Row } from "react-bootstrap";

const AHCCard = ({ item, cart, addRemoveToCart, viewDetails }) => {
	let testCount = item.availableTests.length;
	item.availableProfiles.forEach((profile) => {
		testCount += profile.availableTests.length;
	});

	return (
		<div className="d-flex justify-content-center">
			<div
				className="card-box font-size-smd p-10"
				style={{
					boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)",
					minHeight: "100px",
					maxWidth: "400px",
					width: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
				}}
			>
				<div>
					{item.isSponsored && (
						<div className="justify-items-center top-right-tag sponsored p-x-20">
							Sponsored
						</div>
					)}
					<div className="font-size-md m-t-12">
						<b>{item.packageName}</b>
					</div>
					<div className="font-size-smd">{testCount} Tests</div>
					{item.priceRange > 0 && (
						<div className="font-size-md">
							<span>
								Price Range:
								<b className="text-decoration-line-through">
									INR {item.priceRange}/-
								</b>
							</span>
							<span>{item.discount}% OFF </span>
						</div>
					)}
				</div>
				<Row className="m-t-15 justify-content-center">
					<Col>
						{item.isAvailable ? (
							<>
								<Row className="m-b-10">
									<Col xs={6} md={6}>
										<Button
											variant="primary"
											type="submit"
											className="text-align-center w-100"
											onClick={() =>
												viewDetails(item.packageId, item.packageName)
											}
										>
											View Details
										</Button>
									</Col>
									<Col xs={6} md={6}>
										<Button
											variant={
												item.isAddToCartDisabled ? "secondary" : "primary"
											}
											className="text-align-center w-100"
											onClick={() =>
												addRemoveToCart(
													item.packageId,
													item.packageName,
													item.price,
													item.contractId,
												)
											}
											disabled={item.isAddToCartDisabled}
										>
											{cart.some(
												(cartItem) => cartItem.packageId == item.packageId,
											)
												? "Remove"
												: "Add"}
										</Button>
									</Col>
								</Row>

								{item.isAddToCartDisabled && (
									<span className="m-t-5">
										Only one package can be added to cart at a time
									</span>
								)}
							</>
						) : (
							<div className="text-danger">
								<p className="m-0">Not Available</p>
								<p className="m-0">@ Pincode</p>
							</div>
						)}
					</Col>
				</Row>
			</div>
		</div>
	);
};

const AHCCarousel = ({ ahcPackages, cart, addRemoveToCart, viewDetails }) => {
	return (
		<div className="m-y-20">
			<Row>
				<Col>
					<div className="font-size-md">
						<b>AHC Packages</b>
					</div>
				</Col>
			</Row>
			<Carousel
				interval={null}
				indicators={false}
				controls={true}
				touch={true}
				wrap={false}
				className="m-x-0"
				slide={true}
				style={{
					backgroundColor: "#f8f9fa",
					borderRadius: "10px",
					padding: "5px",
					marginBottom: "20px",
				}}
			>
				{ahcPackages.map((elem, index) => (
					<Carousel.Item key={index}>
						<AHCCard
							item={elem}
							cart={cart}
							addRemoveToCart={addRemoveToCart}
							viewDetails={viewDetails}
						/>
					</Carousel.Item>
				))}
			</Carousel>
		</div>
	);
};

export default AHCCarousel;
